var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconB3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06931 31.6104C3.13897 24.382 5.0092 16.3498 10.68 10.679C19.1414 2.21767 32.8599 2.21767 41.3213 10.679C49.7827 19.1404 49.7827 32.859 41.3213 41.3203C35.6505 46.9911 27.6183 48.8614 20.39 46.931M32.5009 32.4999V19.4999M32.5009 19.4999H19.5009M32.5009 19.4999L10.8339 41.1664",
    stroke: "#00AAFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconB3);
export default __webpack_public_path__ + "static/media/icon-b-3.056ed146ecbc201314d07ff45dba516c.svg";
export { ForwardRef as ReactComponent };